<cac-dialog-layout
  [title]="data.blog ? 'Edit Blog' : 'Create New Blog'"
  subtitle="Enter the required data and save"
  (onSubmit)="onSubmit($event)"
>
  <cac-image-uploader [control]="image" [options]="options" class="h-44" />

  <cac-form-builder [options]="form" class="mt-6" />
  <div *ngIf="form.controls.tags.value && form.controls.tags.value.length > 0" class="mt-4">
    <div class="flex flex-wrap gap-2">
      <div
        *ngFor="let tagId of form.controls.tags.value"
        class="bg-gray-100 rounded-full px-3 py-1 text-sm flex items-center"
      >
        {{ getTagName(tagId) }}
        <button class="ml-2 text-gray-500 hover:text-gray-700" (click)="removeTag(tagId)">×</button>
      </div>
    </div>
  </div>

  <div class="flex gap-3 mt-4">
    <cac-button class="w-fit" (onClick)="openEditor()">Open Editor</cac-button>
    <cac-button class="w-fit" appearance="stroked" (onClick)="saveDraft($event)">Save as Draft</cac-button>

    <cac-button
      *ngIf="data.blog?.isDraft"
      class="w-fit"
      appearance="stroked"
      color="warn"
      (onClick)="restorePreviousVersion($event)"
    >
      Restore Previous Version
    </cac-button>
  </div>
</cac-dialog-layout>
